// TODO: Use here ExperimentalMapHomeCard from Ui-Library

import { ExperimentalMapHomecard } from '@spotahome/ui-library';

import '@spotahome/ui-library/lib/components/Homecard/ExperimentalMapHomecard/ExperimentalMapHomecardWrapper.css';
import '@spotahome/ui-library/lib/components/Homecard/ExperimentalMapHomecard/ExperimentalPrice.css';
import '@spotahome/ui-library/lib/components/Homecard/ExperimentalMapHomecard/ExperimentalHomecardContent.css';
import '@spotahome/ui-library/lib/components/Homecard/ExperimentalMapHomecard/ExperimentalHomecardWrapper.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardImage.css';
import '@spotahome/ui-library/lib/components/Homecard/common/HomecardLabel.css';
import '@spotahome/ui-library/lib/components/Homecard/common/VerifiedLabel.css';
import '@spotahome/ui-library/lib/components/Favourite.css';
import '@spotahome/ui-library/lib/components/Rating.css';

import withStaticMap from '../withStaticMap';

export { SMALL_MAP } from '../withStaticMap';
export default withStaticMap(ExperimentalMapHomecard);
